module.exports = __webpack_public_path__ + "static/media/traffic.d1676bb0.png";